import { useState, useEffect, useCallback, useRef } from 'react';
import './Slider.css';

const images = [
    { src: process.env.PUBLIC_URL + '/carosello/carosello1.jpg', position: 'center top' },
    { src: process.env.PUBLIC_URL + '/carosello/carosello3.jpg', position: 'center 40%' },
    { src: process.env.PUBLIC_URL + '/carosello/carosello4.jpg', position: 'center 20%' },
    { src: process.env.PUBLIC_URL + '/carosello/carosello5.jpg', position: 'center 35%' },
];

// [clone of last, img1, img2, img3, clone of first]
const slides = [images[images.length - 1], ...images, images[0]];

function Slider() {
    const [index, setIndex] = useState(1);
    const [animated, setAnimated] = useState(false);
    const [logoStuck, setLogoStuck] = useState(false);
    const logoRef = useRef<HTMLDivElement>(null);
    const logoNaturalTopRef = useRef(0);

    useEffect(() => {
        const handleScroll = () => {
            // Misura la posizione naturale del logo solo mentre non è ancora
            // agganciato in alto: una volta fixed, getBoundingClientRect
            // restituirebbe le coordinate rispetto al viewport, non al documento.
            if (!logoStuck && logoRef.current) {
                logoNaturalTopRef.current = logoRef.current.getBoundingClientRect().top + window.scrollY;
            }
            setLogoStuck(window.scrollY > logoNaturalTopRef.current);
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [logoStuck]);

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex(prev => {
                // Se siamo già sul clone finale, il reset previsto in
                // handleTransitionEnd non è scattato (es. transitionend perso
                // per tab in background o hot-reload): recupera subito invece
                // di continuare a incrementare oltre le slide reali.
                if (prev >= slides.length - 1) {
                    setAnimated(false);
                    return 1;
                }
                setAnimated(true);
                return prev + 1;
            });
        }, 4500);
        return () => clearInterval(timer);
    }, []);

    const handleTransitionEnd = useCallback(() => {
        if (index === slides.length - 1) {
            // Siamo sul clone della prima slide → salto istantaneo alla vera prima
            setAnimated(false);
            setIndex(1);
        }
    }, [index]);

    const trackStyle: React.CSSProperties = {
        display: 'flex',
        width: `${slides.length * 100}%`,
        height: '100%',
        transform: `translateX(-${index * (100 / slides.length)}%)`,
        transition: animated ? 'transform 1.5s ease-in-out' : 'none',
    };

    const slideStyle: React.CSSProperties = {
        width: `${100 / slides.length}%`,
        height: '100%',
        flexShrink: 0,
    };

    return (
        <div className='slider'>
            <div style={trackStyle} onTransitionEnd={handleTransitionEnd}>
                {slides.map((slide, i) => (
                    <div key={i} style={slideStyle}>
                        <img
                            src={slide.src}
                            alt=""
                            style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: slide.position }}
                        />
                    </div>
                ))}
            </div>
            <div className={`settemotivi-logo${logoStuck ? ' settemotivi-logo-stuck' : ''}`} ref={logoRef}>
                <img src={process.env.PUBLIC_URL + '/settemotivi-logo.png'} alt="" />
            </div>
        </div>
    );
}

export default Slider;